import type { EndpointDef } from '@skynet/data-helpers';

/**
 * Central endpoint definitions — single source of truth for the Projects API.
 *
 * This file drives:
 * - Enhanced API: computed endpoint keys in `enhanceEndpoints`
 * - Hook re-exports: clean name → generated name mapping
 * - MSW mock factories: HTTP method + URL path pattern
 */
export const PROJECTS_API_ENDPOINTS = {
  listProjects: {
    generated: 'projectsAdminControllerListProjectsV1',
    method: 'get',
    path: '/api/v1/admin/projects',
  },
} as const satisfies Record<string, EndpointDef>;

export type ProjectsEndpointName = keyof typeof PROJECTS_API_ENDPOINTS;
